<template>
  <div>
    <div class="return-record-info">
      <crm-button
        v-if="
                  contractAuth.invoiceDownload &&
                  contractAuth.invoiceDownload.toggleStatus
                "
        :buttonType="'plain'"
        :size="'mini'"
        :text="'导出'"
        :disabled="isDownload"
        class="fr mb10"
        @click="handleExportBillsRecord"
      >
      </crm-button>
      <el-dropdown
        v-if="
                  contractAuth.contractAddReceivable &&
                  contractAuth.contractAddReceivable.toggleStatus
                "
        trigger="click"
        @command="handleAddBillsRecord"
        class="fr mb10"
      >
        <crm-button :size="'mini'" :text="'新增开票记录'">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </crm-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="addNew">新增</el-dropdown-item>
          <el-dropdown-item command="addHad">已有开票记录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
      :data="dataList"
      v-loading="billsLoading"
      style="width: 100%; height: calc(100vh - 423px);"
    >
      <el-table-column prop="invoiceTypeName" label="开票类型" align="center"></el-table-column>
      <el-table-column prop="invoiceDate" label="开票时间" align="center"></el-table-column>
      <el-table-column prop="invoiceAmountStr" label="开票金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.invoiceAmountStr || scope.row.invoiceAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invoiceReceivableName" label="发票收款" align="center"></el-table-column>
      <el-table-column prop="billHead" label="发票抬头" align="center"></el-table-column>
      <el-table-column prop="sellerName" label="销售方名称" align="center"></el-table-column>
      <el-table-column prop="planRefundDate" label="预计回款时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.planRefundDate? (scope.row.planRefundDate | formatTimeShow) : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="overdueDate" label="应收款逾期起算日期" align="center" width="170px"></el-table-column>
      <el-table-column prop="requestNo" label="流程编号" align="center" width="170px"></el-table-column>
      <el-table-column prop="status" label="流程状态" align="center"></el-table-column>
      <el-table-column prop="applierName" label="业务申请人" align="center"></el-table-column>
      <el-table-column prop="applierTeamName" label="申请部门" align="center"></el-table-column>
      <el-table-column prop="fileList" label="附件" align="center">
        <template slot-scope="scope">
          <p v-for="item in scope.row.fileList" :key="item.id">
            <a href="javascript:;" @click="getFildUrl(item)">
              {{ item.fileName }}
            </a>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="
                      contractAuth.contractDeleteReceivable &&
                      contractAuth.contractDeleteReceivable.toggleStatus
                    "
            @click="handleDeleteBillsRecord(scope)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="
                      contractAuth.invoiceCount &&
                      contractAuth.invoiceCount.toggleStatus
                    "
      style="height: 28px; line-height: 28px;">
      <span>合同已开票金额（元）：{{ totalInvoiceAmount }}</span>
      <span style="margin-left: 20px;">未开票金额（元）：{{ unbilledAmount }}</span>
    </div>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="dataPage.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="dataPage.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <choose-record ref="chooseRecord" :contract-id="id" :info="info" @success="queryList"/>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions, mapGetters } from 'vuex'
import { newDownloadByUrl, formatTimeShow } from '@/scripts/utils'
import ChooseRecord from './chooseRecord.vue'
import servicesInside from '~api/compact-inside';
import { Loading } from "element-ui";
import projectService from "@/services/api/project";

export default {
  components: {
    CrmButton,
    ChooseRecord,
  },
  props: {
    id: String,
    info: Object,
    detail: Object,
  },
  filters: {
    formatTimeShow,
  },
  data() {
    return {
      isDownload: false,
      billsLoading: false,
      imagePreview: {
        showImage: false,
        url: "",
      },
      dataList: [],
      dataPage: {
        pageNumber: 1,
        pageSize: 5,
      },
      totalCount: 0,
      totalInvoiceAmount: 0,
      unbilledAmount: 0,
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      userInfo: "authority/userInfo",
    }),
  },
  methods: {
    ...mapActions({
      deleteBillsRecord: "compact/deleteBillsRecord",
    }),
    handleSizeChange(value) {
      this.dataPage.pageNumber = 1
      this.dataPage.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.dataPage.pageNumber = value
      this.queryList()
    },
    // 导出开票记录
    handleExportBillsRecord() {
      const url = `/api/crmInvoiceRecord/download/invoice?contractId=${this.id}`;
      this.handleDownloadRecord(url);
    },
    async handleDownloadRecord(url) {
      try {
        this.isDownload = true;
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isDownload = false;
    },
    // 打开新增开票记录窗口
    handleAddBillsRecord(type) {
      if (type === "addHad") {
        // eslint-disable-next-line no-unused-expressions
        this.$refs.chooseRecord && this.$refs.chooseRecord.open()
      } else { // OA跳转
        this.handleAdd()
      }
    },
    async handleAdd() {
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      const isTest = window.location.hostname.includes('crm.guahao-test.com')
      const tokenData = await projectService.getOaTokenInside();
      const oaEnv = isTest ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const oaUrl = isTest ? `#/main/workflow/req?iscreate=1&workflowid=120` : `#/main/workflow/req?iscreate=1&workflowid=178`
      const kpfs = (this.detail.kpfs[this.detail.kpfs.length - 1] === '票') ? 1 : 0
      const param = isTest
        ? `&field12388=0&field12359=${this.info.contractNo}&field12363=${kpfs}&field12390=${this.detail.zxysdy}&field12543=${this.detail.wfqyzt}&field12325_1=${this.detail.wfqyzt}`
        : `&field15093=0&field12463=${this.info.contractNo}&field12467=${kpfs}&field15141=${this.detail.zxysdy}&field17212=${this.detail.wfqyzt}&field12477_1=${this.detail.wfqyzt}`
      const OAUrl = `${oaEnv}?ssoToken=${tokenData.data.data}${oaUrl}${param}`;
      window.open(OAUrl);
      setTimeout(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }, 2000);
    },
    // 获取发票记录
    async queryList() {
      try {
        this.billsLoading = true;
        this.getCountNumber()
        const { pageNumber, pageSize } = this.dataPage;
        const { data } = await servicesInside.crmInvoiceRecordInvoice({
          contractId: this.id,
          pageNumber,
          pageSize,
        });
        this.billsLoading = false;
        this.dataList = data.results;
        this.dataPage.pageNumber = data.pageNumber;
        this.dataPage.pageSize = data.pageSize;
        this.totalCount = data.totalCount;
      } catch (e) {
        console.log(e)
        this.billsLoading = false;
      }
    },
    async getCountNumber() {
      try {
        const { data } = await servicesInside.crmInvoiceRecordCount({
          contractId: this.id,
        });
        this.totalInvoiceAmount = data.totalInvoiceAmount;
        this.unbilledAmount = data.unbilledAmount;
      } catch (e) {
        console.log(e)
      }
    },
    // 删除发票记录
    handleDeleteBillsRecord(scope) {
      this.$confirm("当前操作，将把该开票记录从合同删除，是否确认？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBillsRecord({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.dataPage.pageNumber = 1
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    // 关闭图片预览
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
  },
}
</script>
